module.exports = __webpack_public_path__ + "static/media/inside_your_computer.c5bbf49d.jpg";